module.exports = __webpack_public_path__ + "static/media/stop-start.6f700763.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stop-start.svg
// module id = 864
// module chunks = 0